export * from './array-fill.js';
export * from './array-find.js';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
